import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';


import { ApiError, MessageService } from '../../../../../core';
import { RepresentanteClassificacaoCliente } from '../representante-classificacao-cliente';
import { GrupoClassificacaoClassificavelFormComponent } from '../../../../grupo-classificacao/classificavel/form';
import { GrupoClassificacao } from '../../../../grupo-classificacao';
import { GrupoClassificacaoClassificacao } from '../../../../grupo-classificacao/classificacao';
import { GrupoClassificacaoSituacaoHttpService } from '../../../../grupo-classificacao/situacao';

@Component({
    selector: 'sgt-representante-classificacao-cliente-form',
    templateUrl: './representante-classificacao-cliente-form.component.html',
    styleUrls: ['./representante-classificacao-cliente-form.component.less']
})
export class RepresentanteClassificacaoClienteFormComponent {
    /** ID do representante */
    @Input() idRepresentante: number;

    /** Classificações de clientes do representante */
    @Input() entities: RepresentanteClassificacaoCliente[];
    /** Ao alterar as classificações de client */
    @Output() entitiesChange = new EventEmitter<RepresentanteClassificacaoCliente[]>();

    @ViewChild('form') form: GrupoClassificacaoClassificavelFormComponent;

    constructor(private messageService: MessageService,
                private grupoClassificacaoSituacaoHttpService: GrupoClassificacaoSituacaoHttpService) { }

    /** Carrega o grupo de classificação de cadastro de clientes */
    private loadGrupoClassificacao(): Promise<GrupoClassificacao> {
        return new Promise<GrupoClassificacao>((resolve, reject) => {
            this.grupoClassificacaoSituacaoHttpService.loadCadastroCliente()
                .pipe(
                    take(1)
                )
                .subscribe(
                    grupoClassificacao => resolve(grupoClassificacao),
                    (error: ApiError) => reject(error)
                );
        });
    }

    /** Insere uma classificação de cliente no representante através da classificação do grupo */
    private insertClassificacao(grupoClassificacaoClassificacao: GrupoClassificacaoClassificacao) {
        const entity = new RepresentanteClassificacaoCliente();
        entity.idRepresentante = this.idRepresentante;

        // Setando as informações do grupo de classificação na entidade
        this.form.insertClassificacao(entity, grupoClassificacaoClassificacao);

        this.entities.push(entity);
    }

    /** Insere classificações do grupo de classificação de cadastro de clientes no representante */
    insert() {
        this.loadGrupoClassificacao()
            .then(grupoClassificacao => {
                if (grupoClassificacao) {
                    grupoClassificacao.classificacoes?.forEach(grupoClassificacaoClassificacao => this.insertClassificacao(grupoClassificacaoClassificacao));
                } else {
                    this.entities = [];
                }

                this.entitiesChange.emit(this.entities);
            })
            .catch((error: ApiError) => this.messageService.error(error.message, 'Erro ao adicionar os segmentos padrões dos clientes no novo representante', error));
    }

    /** Verifica se as classificações estão válidas */
    isValid(): boolean {
        return this.form.isValid();
    }
}
